import type { LanguageMap, OptionalLanguageMap } from "@/services/category.service";

export function localizedText(value: LanguageMap, language = "en"): string {
  return value[language] ?? "";
}

export function completeLanguageMap(
  languages: readonly string[],
  values: Record<string, string>,
): LanguageMap {
  return Object.fromEntries(languages.map((language) => [language, values[language]?.trim() ?? ""]));
}

export function sparseLanguageMap(
  languages: readonly string[],
  values: Record<string, string>,
): OptionalLanguageMap {
  return Object.fromEntries(languages.flatMap((language) => {
    const value = values[language]?.trim();
    return value ? [[language, value]] : [];
  }));
}
